import { Component, HostListener, signal } from '@angular/core';

@Component({
  selector: 'app-info-tooltip',
  standalone: true,
  templateUrl: './info-tooltip.component.html',
})
export class InfoTooltipComponent {
  // Rendered fixed-position (via mouse coordinates) so it isn't clipped by a scrollable
  // ancestor. Hover shows a preview (desktop); a click/tap "pins" it open (touch devices,
  // where hover doesn't fire) until tapped again or elsewhere.
  position = signal<{ top: number; left: number } | null>(null);
  private pinned = false;

  show(event: MouseEvent): void {
    if (this.pinned) return;
    this.setPositionFrom(event.currentTarget as HTMLElement);
  }

  hide(): void {
    if (this.pinned) return;
    this.position.set(null);
  }

  toggle(event: MouseEvent): void {
    event.stopPropagation();
    this.pinned = !this.pinned;
    if (this.pinned) {
      this.setPositionFrom(event.currentTarget as HTMLElement);
    } else {
      this.position.set(null);
    }
  }

  private setPositionFrom(el: HTMLElement): void {
    const rect = el.getBoundingClientRect();
    this.position.set({ top: rect.top, left: rect.left + rect.width / 2 });
  }

  @HostListener('document:click')
  closePinned(): void {
    if (this.pinned) {
      this.pinned = false;
      this.position.set(null);
    }
  }
}
